/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:fd50e507-c37e-4950-a86e-7e6568bb5d40",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xLq05rWhb",
    "aws_user_pools_web_client_id": "45ra3tpmh7cbe8knfj0gjmmh2o",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME",
        "FAMILY_NAME",
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "erp-us",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
